var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quote"},[_c('p',{staticClass:"paragraph",domProps:{"innerHTML":_vm._s(_vm.quotes[_vm.number].quote)}}),_c('p',{staticClass:"paragraph"},[_vm._v("- "+_vm._s(_vm.quotes[_vm.number].name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }